import { CrudState } from "@/store/Crud/State";

export class State extends CrudState {
  selectedStudent: any = null;
  registrationProcessStatuses: Array<any> = [];
}
